export const fileIcons = {
  pdf: "fa-file-pdf",
  png: "fa-file-image",
  jpeg: "fa-file-image",
  jpg: "fa-file-image",
  csv: "fa-file-csv",
  xls: "fa-file-excel",
  xlsx: "fa-file-excel",
  doc: "fa-file-word",
  docx: "fa-file-word",
  default: "fa-file",
};
